var _defs, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack167({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 10.18,
    r: 4.32
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.17,
    y1: 1.5,
    x2: 6.17,
    y2: 13.97
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.83,
    y1: 1.5,
    x2: 9.83,
    y2: 13.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack167);
export default __webpack_public_path__ + "static/media/Symbolpack_1_67.f906341db84ed46a959252de46574b7b.svg";
export { ForwardRef as ReactComponent };